import request from '@/utils/index'
import { isReadOk, hasUnavailableMarker, isNeedLogin, failMessage } from '@/utils/responseGuard'
import { h5Text } from '@/utils/h5I18n'

function h5EntryBlockedMessage() {
  return h5Text('service_unavailable') || 'Service temporarily unavailable. Please try again later.'
}

// H5 鐧诲綍鎬侀挶鍖呭叆鍙ｅ搷搴?guard(Step6:鏁村 H5_ENTRY_* 閿泦鏈哄櫒鏀舵暃鍒?responseGuard 鏍?銆?
// need_login 浠绘剰妯″紡浼樺厛杩斿洖鐧诲綍鎬佸３;read/gameRead 鈫?isReadOk(fail-open:鍙 success===false/鏄庣‘ fail/need_login);
// write(榛樿)鈫?hasUnavailableMarker(fail-closed:涓嶅彲鐢?闃绘柇/鍋囪瘉鏄?marker 鍗虫嫤)銆?
function guardH5LoginWalletEntryResponse(response, options = {}) {
  if (isNeedLogin(response)) {
    const message = failMessage(response, h5EntryBlockedMessage())
    return {
      status: 'need_login',
      code: 'need_login',
      success: false,
      message,
      content: { code: 'need_login', message },
      data: { code: 'need_login', message }
    }
  }
  const isReadMode = options.mode === 'read' || options.mode === 'gameRead'
  const blocked = isReadMode ? !isReadOk(response) : hasUnavailableMarker(response)
  if (!blocked) return response
  const message = failMessage(response, h5EntryBlockedMessage())
  return {
    status: 'fail',
    code: 'fail',
    success: false,
    message,
    entryBlocked: true,
    content: { entryBlocked: true, message },
    data: { entryBlocked: true, message }
  }
}

function h5EntryPost(url, data) {
  return request.post(url, data).then(response => guardH5LoginWalletEntryResponse(response))
}

function h5AuthTokenPost(url, data) {
  return request.post(url, data)
}

function h5EntryReadPost(url, data) {
  return request.post(url, data).then(response => guardH5LoginWalletEntryResponse(response, { mode: 'read' }))
}

function h5GameReadPost(url, data) {
  return request.post(url, data).then(response => guardH5LoginWalletEntryResponse(response, { mode: 'gameRead' }))
}

function h5GameReadGet(url, config) {
  return request.get(url, config).then(response => guardH5LoginWalletEntryResponse(response, { mode: 'gameRead' }))
}

// 1.鐧诲綍鎺ュ彛
export function Login(data) {
  return h5EntryPost('/login/login', data)
}
export function Register(data) {
  return h5EntryPost('/register/register', data)
}
//閫€鍑虹櫥褰?
export function Logout(data) {
  return h5EntryPost('/logout', data)
}

//鍒濆鍖?
export function Init(data) {
  return h5EntryReadPost('/profile/init', data)
}
// 鑾峰彇banner鍒楄〃
export function GetBannerList(data) {
  return request.post('/home/page/banner/list', data)
}
export function GetCsLink(data) {
  return request.post('/getCsLink', data)
}
export function GetHomeGameList(data) {
  return h5GameReadPost('/game/getHomeGameList', data)
}
// 娓告垙绱犳潗/棰勮鍥惧垪琛?GET
export function GetGameMaterialList(params) {
  return h5GameReadGet('/game/getGameMaterialList', { params })
}
export function SystemAnnouncement(data) {
  return request.post('/promo/systemAnnouncement', data)
}
export function NoticeList(data) {
  return request.post('/system/noticeList', data)
}
export function NoticeDetails(data) {
  return h5EntryPost('/noticeDetails', data)
}
export function NoticeReadAll(data) {
  return h5EntryPost('/system/notice/readAll', data)
}
export function NoticeDeleteRead(data) {
  return h5EntryPost('/system/notice/deleteRead', data)
}
export function GetPromoRule(data) {
  return request.post('/activity/getPromoRule', data)
}
export function RedPacket(data) {
  return h5EntryPost('/activity/redPacket', data)
}
export function GetRedPacket(data) {
  return h5EntryPost('/activity/getRedPacket', data)
}
export function RedPacketReceiveRecord(data) {
  return request.post('/activity/redPacketReceiveRecord', data)
}
export function GameBalanceList(data) {
  return h5EntryReadPost('/gameBalanceList', data)
}
export function GetSubUserList(data) {
  return h5EntryReadPost('/agent/getSubUserList', data)
}
export function GetHomeWinningGameList(data) {
  return request.post('/game/getHomeWinningGameList', data)
}
export function GetPromoDailyRelief(data) {
  return h5EntryReadPost('/promo/getPromoDailyRelief', data)
}
export function GetTeamRebateInit(data) {
  return request.post('/promo/getTeamRebateInit', data)
}
export function GetVipAwardInit(data) {
  return request.post('/activity/getVipAwardInit', data)
}
export function GetSignIn(data) {
  return h5EntryReadPost('/activity/getSignIn', data)
}
export function GetSignDaily(data) {
  return h5EntryReadPost('/activity/getSignDaily', data)
}
export function SignDaily(data) {
  return h5EntryPost('/activity/signDaily', data)
}
export function VnRechargeInitS(data) {
  return h5EntryReadPost('/recharge/vnRechargeInitS', data)
}
export function WithdrawInit(data) {
  return h5EntryReadPost('/withdraw/init', data)
}
export function AddBankCardInit(data) {
  return h5EntryReadPost('/profile/addBankCardInit', data)
}
export function AddBankCard(data) {
  return h5EntryPost('/profile/addBankCard', data)
}
export function RealnameCert(data) {
  return h5EntryPost('/profile/realnameCert', data)
}
export function ChangePrivacyPwd(data) {
  return h5EntryPost('/security/changePrivacyPwd', data)
}
export function CapitalDetails(data) {
  return h5EntryReadPost('/capital/capitalDetails', data)
}
export function VipInit(data) {
  return h5EntryReadPost('/vip/init', data)
}
export function ChangeLoginPwd(data) {
  return h5EntryPost('/security/changeLoginPwd', data)
}
export function GetCaptcha(data) {
  return h5EntryPost('/security/getCaptcha', data)
}
export function BankCardInfo(data) {
  return h5EntryReadPost('/profile/bankCardInfo', data)
}
export function DelBankCard(data) {
  return h5EntryPost('/profile/delBankCard', data)
}
export function SetDefaultBankCard(data) {
  return h5EntryPost('/profile/setDefaultBankCard', data)
}
export function SetHeadUrl(data) {
  return h5EntryPost('/setHeadUrl', data)
}
export function GetTeamReports(data) {
  return h5EntryReadPost('/agent/getTeamReports', data)
}
export function GetTeamTotalReports(data) {
  return h5EntryReadPost('/agent/getTeamTotalReports', data)
}
export function GetThirdGameBetRecord(data) {
  return request.post('/game/getThirdGameBetRecord', data)
}
export function ForwardGame(data) {
  return h5EntryPost('/game/forwardGame', data)
}
export function ReportPromoPanelEvent(data) {
  return h5EntryPost('/promo/reportPromoPanelEvent', data)
}
export function GetLuckyRoulette(data) {
  return h5EntryReadPost('/promo/getLuckyRoulette', data)
}
export function LuckyRoulette(data) {
  return h5EntryPost('/promo/luckyRoulette', data)
}
export function GetLuckyRouletteRecord(data) {
  return h5EntryReadPost('/promo/getLuckyRouletteRecord', data)
}
export function TreasureReceiveInit(data) {
  return h5EntryReadPost('/promo/treasureReceiveInit', data)
}
export function ReceiveTreasure(data) {
  return h5EntryPost('/promo/receiveTreasure', data)
}
export function Pay(data) {
  return h5EntryPost('/recharge/pay', data)
}
export function Withdraw(data) {
  return h5EntryPost('/withdraw/withdraw', data)
}
export function ReceivePromoReliefAmount(data) {
  return h5EntryPost('/promo/receivePromoReliefAmount', data)
}
export function ReceiveTeamRebateAmount(data) {
  return h5EntryPost('/promo/receiveTeamRebateAmount', data)
}
export function GetVipAward(data) {
  return h5EntryPost('/activity/getVipAward', data)
}
export function SignIn(data) {
  return h5EntryPost('/activity/signIn', data)
}
export function ReceiveLuckyRouletteBonus(data) {
  return h5EntryPost('/promo/receiveLuckyRouletteBonus', data)
}
export function GetLuckyRouletteLatestAwards(data) {
  return request.post('/promo/getLuckyRouletteLatestAwards', data)
}
//facebook涓婃姤
export function GetIsFbReport(data) {
  return h5EntryPost('/getIsFbReport', data)
}
export function fbReportSuccess(data) {
  return h5EntryPost('/fbReportSuccess', data)
}

export function GetRWHistory(data) {
  return h5EntryReadPost('/capital/getRWHistory', data)
}

export function ActivitygetRegisterAward(data) {
  return h5EntryReadPost('/activity/getRegisterAward', data)
}

export function ActivityreceiveRegisterAward(data) {
  return h5EntryPost('/activity/receiveRegisterAward', data)
}

export function GetUserGameRecordList(data) {
  return request.post('/game/getUserGameRecordList', data)
}
export function MainInit(data) {
  return request.post('/main/init', data)
}
export function LotteryInit(data) {
  return request.post('/lottery/init', data)
}
export function LotteryBetV2(data) {
  return h5EntryPost('/lottery/betV2', data)
}
export function GetNGNDrawHistory(data) {
  return request.post('/lottery/getNGNDrawHistory', data)
}
export function GetTodayBetRecord(data) {
  return request.post('/lottery/getTodayBetRecord', data)
}
export function GetBetList(data) {
  return request.post('/lottery/getBetList', data)
}
export function BetDetail(data) {
  return request.post('/betDetail', data)
}
export function CancelBet(data) {
  return h5EntryPost('/agent/risk/cancelBet', data)
}
export function GetServerDateTime(data) {
  return request.post('/lottery/getServerDateTime', data)
}
export function GetBRDrawHistory(data) {
  return request.post('/lottery/getBRDrawHistory', data)
}
export function FreshIssueInfo(data) {
  return request.post('/lottery/freshIssueInfo', data)
}
export function GetHomeWinningLottoList(data) {
  return request.post('/game/getHomeWinningLottoList', data)
}
export function GetLotteryLatestResults(data) {
  return request.post('/lottery/getLotteryLatestResults', data)
}
export function GetLotteryList(data) {
  return request.post('/main/getLotteryList', data)
}
export function LastOrderDetail(data) {
  return request.post('/lastOrderDetail', data)
}
export function RefreshExchangeRate(data) {
  return request.post('/refreshExchangeRate', data)
}
export function UpayStatusorderNo(data) {
  return h5EntryPost('/recharge/upayStatus', data)
}
export function GetPlatformList(data) {
  return request.post('/getPlatformList', data)
}
export function GetInvitationID(data) {
  return request.post('/getInvitationID', data)
}
export function NewPlayerGiftPackInit(data) {
  return request.post('/promo/newPlayerGiftPackInit', data)
}
export function ReceiveNewPlayerGiftPack(data) {
  return h5EntryPost('/promo/receiveNewPlayerGiftPack', data)
}
export function TreasureBoxInit(data) {
  return request.post('/promo/treasureBoxInit', data)
}
export function TaskCenterNewbieInit(data) {
  return h5EntryReadPost('/promo/taskCenterNewbieInit', data)
}
export function TaskCenterDailyInit(data) {
  return h5EntryReadPost('/promo/taskCenterDailyInit', data)
}
export function TaskCenterWeeklyInit(data) {
  return h5EntryReadPost('/promo/taskCenterWeeklyInit', data)
}
export function ClaimTaskReward(data) {
  return h5EntryPost('/promo/claimTaskReward', data)
}
export function ClaimProgressReward(data) {
  return h5EntryPost('/promo/claimProgressReward', data)
}

// VIP
export function CashBackInit(data) {
  return h5EntryReadPost('/activity/cashBackInit', data)
}
export function GetCashBack(data) {
  return h5EntryPost('/activity/getCashBack', data)
}
export function ChangeExtend(data) {
  return h5EntryPost('/profile/changeExtend', data)
}
export function BirthdayAwardInit(data) {
  return h5EntryPost('/vip/birthdayAwardInit', data)
}
export function ReceiveBirthdayAward(data) {
  return h5EntryPost('/vip/receiveBirthdayAward', data)
}

// Google OAuth
export function GetGoogleAuthorizingUrl(data) {
  return h5EntryPost('/login/getGoogleAuthorizingUrl', data)
}
export function GoogleAuthCodeLogin(data) {
  return h5AuthTokenPost('/login/googleAuthCodeLogin', data)
}
export function GoogleRegister(data) {
  return h5EntryPost('/register/googleRegister', data)
}
export function BindPhone(data) {
  return h5EntryPost('/profile/bindPhone', data)
}
